import React, {createContext, useState, Dispatch, SetStateAction} from 'react';

type ContextProps = {
  refreshQuestionPage?: () => Promise<void>;
  setRefreshQuestionPage: Dispatch<SetStateAction<(() => Promise<void>) | undefined>>;
};

export const DashboardContext = createContext<ContextProps>({
  refreshQuestionPage: undefined,
  setRefreshQuestionPage: () => {},
});

type DashboardProviderProps = {
  children: React.ReactNode;
};

export const DashboardProvider = ({ children }: DashboardProviderProps) => {
  const [refreshQuestionPage, setRefreshQuestionPage] = useState<(() => Promise<void>) | undefined>();

  return (
    <DashboardContext.Provider
      value={{ refreshQuestionPage, setRefreshQuestionPage }}
    >
      {children}
    </DashboardContext.Provider>
  );
};
